import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';
import SplitButton from '../../shared/SplitButton';
import DownloadIcon from '../../shared/DownloadIcon';
import DropDownMenu from '../../shared/DropDownMenu';
import TrashIcon from '../../shared/TrashIcon';
import { styled, useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const WhiteBorderTextField = styled(TextField)`
  .MuiOutlinedInput-notchedOutline {
    border-color: white;
  }
  & .MuiOutlinedInput {
      border-color: white;
      
    &.Mui-focused fieldset {
      border-color: white;
      
    }
    &.MuiOutlinedInput-notchedOutline {
        border-color: white;
    }
  }
  
`;

export default function EventListTopTools() {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Grid item={true} xs={12} >
            <Stack sx={{ position: "relative", justifyContent: 'space-between', marginTop: '15px' }} direction="row" spacing={0}>
                <Stack direction="row" spacing={2} >
                    <WhiteBorderTextField
                        sx={{
                            backgroundColor: 'white',
                            borderRadius: 4,
                            borderBottomColor: 'white',
                        }}
                        placeholder='Search Events'
                        InputProps={{

                            
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon color="secondary"


                                        fontSize='large'
                                    />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <Button variant="contained" color="secondary">Search</Button>
                            ),
                        }}
                    />

                    <SplitButton options={['Sort By', 'Name']} />
                </Stack>

                <Stack direction="row" spacing={2} mr={1}>
                    <IconButton color="secondary" aria-label="delete" component="span"
                        sx={{
                            border: 0,
                            boxShadow: '0px 0px 20px ' + theme.palette.grey[400],
                            borderRadius: 2,
                            backgroundColor: 'white',
                            pl: 1, pr: 1
                        }}>
                        <TrashIcon viewBox="0 0 46 46" />
                    </IconButton>

                    <DropDownMenu />

                    <Button color="secondary" sx={{
                        boxShadow: '0px 0px 20px ' + theme.palette.grey[400],
                        border: 0,
                        borderRadius: 2,
                        backgroundColor: 'white',
                        fontWeight: 'bold',
                        fontSize: '14px',
                        color: 'secondary.main'
                    }}
                        size="large"
                        endIcon={<DownloadIcon viewBox="0 0 42 37" sx={{ mt: '4px' }} />}
                    >
                        {t('app_download')}
                    </Button>


                </Stack>
            </Stack>


        </Grid>

    )
}
